"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWorkerAsync = exports.sleepAsync = void 0;
var timer_1 = __importDefault(require("./timer"));
function get_browser() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'ie', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/);
        if (tem != null) {
            var version = tem[1];
            if (!version) {
                var splits = ua.split(tem[0] + "/");
                if (splits.length > 1) {
                    version = splits[1];
                }
            }
            return { name: 'opera', version: version };
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0].toLowerCase(),
        version: M[1]
    };
}
var keepAliveServiceWorkerTimeoutId = null;
var sleepAsync = function (milliseconds) {
    return new Promise(function (resolve) { return timer_1.default.setTimeout(resolve, milliseconds); });
};
exports.sleepAsync = sleepAsync;
var keepAlive = function () {
    fetch('/OidcKeepAliveServiceWorker.json');
    (0, exports.sleepAsync)(230 * 1000).then(keepAlive);
};
var isServiceWorkerProxyActiveAsync = function () {
    return fetch('/OidcKeepAliveServiceWorker.json', {
        headers: {
            'oidc-vanilla': "true"
        }
    })
        .then(function (response) {
        return response.statusText === 'oidc-service-worker';
    });
};
var sendMessageAsync = function (registration) { return function (data) {
    return new Promise(function (resolve, reject) {
        var messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = function (event) {
            if (event.data && event.data.error) {
                reject(event.data.error);
            }
            else {
                resolve(event.data);
            }
        };
        registration.active.postMessage(data, [messageChannel.port2]);
    });
}; };
var initWorkerAsync = function (serviceWorkerRelativeUrl, configurationName) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, name, version, registration, err_1, saveItemsAsync, loadItemsAsync, getAccessTokenPayloadAsync, clearAsync, initAsync, startKeepAliveServiceWorker;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!navigator.serviceWorker || !serviceWorkerRelativeUrl) {
                    return [2 /*return*/, null];
                }
                _a = get_browser(), name = _a.name, version = _a.version;
                if (name == "chrome" && parseInt(version) < 90) {
                    return [2 /*return*/, null];
                }
                if (name == "opera") {
                    if (!version) {
                        return [2 /*return*/, null];
                    }
                    if (parseInt(version.split(".")[0]) < 80) {
                        return [2 /*return*/, null];
                    }
                }
                if (name == "ie") {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, navigator.serviceWorker.register(serviceWorkerRelativeUrl)];
            case 1:
                registration = _b.sent();
                _b.label = 2;
            case 2:
                _b.trys.push([2, 4, , 5]);
                return [4 /*yield*/, navigator.serviceWorker.ready];
            case 3:
                _b.sent();
                return [3 /*break*/, 5];
            case 4:
                err_1 = _b.sent();
                return [2 /*return*/, null];
            case 5:
                saveItemsAsync = function (items) {
                    return sendMessageAsync(registration)({ type: "saveItems", data: items, configurationName: configurationName });
                };
                loadItemsAsync = function () {
                    return sendMessageAsync(registration)({ type: "loadItems", data: null, configurationName: configurationName });
                };
                getAccessTokenPayloadAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, sendMessageAsync(registration)({
                                    type: "getAccessTokenPayload",
                                    data: null,
                                    configurationName: configurationName
                                })];
                            case 1:
                                result = _a.sent();
                                // @ts-ignore
                                return [2 /*return*/, result.accessTokenPayload];
                        }
                    });
                }); };
                clearAsync = function () {
                    return sendMessageAsync(registration)({ type: "clear", data: null, configurationName: configurationName });
                };
                initAsync = function (oidcServerConfiguration, where) { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, sendMessageAsync(registration)({
                                    type: "init",
                                    data: { oidcServerConfiguration: oidcServerConfiguration, where: where },
                                    configurationName: configurationName
                                })];
                            case 1:
                                result = _a.sent();
                                // @ts-ignore
                                return [2 /*return*/, { tokens: result.tokens }];
                        }
                    });
                }); };
                startKeepAliveServiceWorker = function () {
                    if (keepAliveServiceWorkerTimeoutId == null) {
                        keepAliveServiceWorkerTimeoutId = "not_null";
                        keepAlive();
                    }
                };
                return [2 /*return*/, {
                        saveItemsAsync: saveItemsAsync,
                        loadItemsAsync: loadItemsAsync,
                        clearAsync: clearAsync,
                        initAsync: initAsync,
                        getAccessTokenPayloadAsync: getAccessTokenPayloadAsync,
                        startKeepAliveServiceWorker: startKeepAliveServiceWorker,
                        isServiceWorkerProxyActiveAsync: isServiceWorkerProxyActiveAsync
                    }];
        }
    });
}); };
exports.initWorkerAsync = initWorkerAsync;
//# sourceMappingURL=initWorker.js.map